export default {"src":"/_next/static/media/contante-betaling.d05b650d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};